exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.description-text[data-v-c4982bfc] {\n  margin-top: 15px;\n  width: 50%;\n}\n.licence-note[data-v-c4982bfc] {\n  min-height: 100px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c4982bfc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/companies/mod24settings/CompaniesLicence.vue
// module id = Uoo3
// module chunks = 0